import React, { useState, useEffect } from 'react'
import { useSelector } from "react-redux";
import { templatesSelector } from "slices/templateSlice";
import moment from 'moment';
import { fetchTemplates } from 'slices/templateSlice';
import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import ErrorMessage from 'components/common/ErrorMessage';
import { TimeInput } from 'components/template/TemplateForm';
import { RateInput } from 'components/template/TemplateForm';
import { UnitSelect } from 'components/template/TemplateForm';
import { Select } from 'components/common/Select';
import { filterIncremental } from 'components/template/TemplateForm';

const LanguageTiers = ({ control, errors, item, dispatch, setValue, watch, error, sendClientData }) => {
    const { templates } = useSelector(templatesSelector);
    const [changeTemplate, setChangeTemplate] = useState();

    const handleNormalHoursChange = () => {
        const normalHourStartTime = watch("normal_hour_start_time");
        const normalHourEndTime = watch("normal_hour_end_time");

        if (normalHourStartTime && normalHourEndTime) {
            const normalStart = moment(normalHourStartTime, "HH:mm");
            const normalEnd = moment(normalHourEndTime, "HH:mm");

            const afterStart = moment(normalEnd).add(1, "minutes");
            const afterEnd = moment(normalStart).subtract(1, "minutes").add(1, "day");

            setValue("after_hour_start_time", afterStart.format("HH:mm"));
            setValue("after_hour_end_time", afterEnd.format("HH:mm"));
        }
    };

    const handleAfterHoursChange = () => {
        const afterHourStartTime = watch("after_hour_start_time");
        const afterHourEndTime = watch("after_hour_end_time");

        if (afterHourStartTime && afterHourEndTime) {
            const afterStart = moment(afterHourStartTime, "HH:mm");
            const afterEnd = moment(afterHourEndTime, "HH:mm");

            const normalStart = moment(afterEnd).add(1, "minutes").subtract(1, "day");
            const normalEnd = moment(afterStart).subtract(1, "minutes");

            setValue("normal_hour_start_time", normalStart.format("HH:mm"));
            setValue("normal_hour_end_time", normalEnd.format("HH:mm"));
        }
    };

    const handleChangeMinDuration = (value) => {
        if (value == "minute" || value == "30_minute") {
            templates.forEach((element, index) => {
                setValue(`interpretationRates.opi_normal_mins_time_unit.${index}`, 'minute')
                setValue(`interpretationRates.vri_normal_mins_time_unit.${index}`, 'minute')
                setValue(`interpretationRates.inperson_normal_mins_time_unit.${index}`, 'minute')
                setValue(`interpretationRates.opi_after_mins_time_unit.${index}`, "minute");
                setValue(`interpretationRates.vri_after_mins_time_unit.${index}`, "minute");
                setValue(`interpretationRates.inperson_after_mins_time_unit.${index}`, "minute");
            });
        } else {
            templates.forEach((element, index) => {
                setValue(`interpretationRates.opi_normal_mins_time_unit.${index}`, 'hour')
                setValue(`interpretationRates.vri_normal_mins_time_unit.${index}`, 'hour')
                setValue(`interpretationRates.inperson_normal_mins_time_unit.${index}`, 'hour')
                setValue(`interpretationRates.opi_after_mins_time_unit.${index}`, "hour");
                setValue(`interpretationRates.vri_after_mins_time_unit.${index}`, "hour");
                setValue(`interpretationRates.inperson_after_mins_time_unit.${index}`, "hour");
            });
        }
    }

    // #region template dropdown
    const [filterTemplate, setfilterTemplates] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.client_template?.name && item?.client_template?.id) {
            setfilterTemplates({
                label: item?.client_template?.name || "",
                value: item?.client_template?.id || ""
            })
        } else {
            setfilterTemplates(null)
        }
    }, [item?.client_template])

    const filteredTemplateLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchTemplates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    const selectedTemplate = templates?.find((i => i.id === filterTemplate?.value))

    useEffect(() => {
        if (changeTemplate) {
            sendClientData(changeTemplate?.interpretation_rates?.map(i => i?.tier_id))
        } else if (item?.interpretation_rates) {
            sendClientData(item?.interpretation_rates?.map(i => i?.client_tier_id))
        } else {
            sendClientData(selectedTemplate?.interpretation_rates?.map(i => i?.tier_id))
        }
    }, [selectedTemplate, item?.interpretation_rates, changeTemplate])

    useEffect(() => {
        setValue('normal_hour_start_time', (item || selectedTemplate)?.normal_hour_start_time || '')
        setValue('normal_hour_end_time', (item || selectedTemplate)?.normal_hour_end_time || '')
        setValue('after_hour_start_time', (item || selectedTemplate)?.after_hour_start_time || '')
        setValue('after_hour_end_time', (item || selectedTemplate)?.after_hour_end_time || '')
        setValue('grace_period', (item || selectedTemplate)?.grace_period || '')
        setValue('incremental', (item || selectedTemplate)?.incremental || '')
        setValue('rush_fee', (item || selectedTemplate)?.rush_fee || '')

        setValue('interpretationRates.opi_normal_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_normal_rate) || '')
        setValue('interpretationRates.vri_normal_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_normal_rate) || '')
        setValue('interpretationRates.inperson_normal_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_normal_rate) || '')
        setValue('interpretationRates.opi_normal_rate_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_normal_rate_time_unit) || ['hour'])
        setValue('interpretationRates.vri_normal_rate_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_normal_rate_time_unit) || ['hour'])
        setValue('interpretationRates.inperson_normal_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_normal_time_unit) || ['hour'])
        setValue('interpretationRates.opi_normal_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_normal_mins) || '')
        setValue('interpretationRates.vri_normal_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_normal_mins) || '')
        setValue('interpretationRates.inperson_normal_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_normal_mins) || '')
        setValue('interpretationRates.opi_normal_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_normal_mins_time_unit) || ['hour'])
        setValue('interpretationRates.vri_normal_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_normal_mins_time_unit) || ['hour'])
        setValue('interpretationRates.inperson_normal_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_normal_mins_time_unit) || ['hour'])

        setValue('interpretationRates.opi_after_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_after_rate) || '')
        setValue('interpretationRates.vri_after_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_after_rate) || '')
        setValue('interpretationRates.inperson_after_rate', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_after_rate) || '')
        setValue('interpretationRates.opi_after_rate_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_after_rate_time_unit) || ['hour'])
        setValue('interpretationRates.vri_after_rate_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_after_rate_time_unit) || ['hour'])
        setValue('interpretationRates.inperson_after_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_after_time_unit) || ['hour'])
        setValue('interpretationRates.opi_after_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_after_mins) || '')
        setValue('interpretationRates.vri_after_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_after_mins) || '')
        setValue('interpretationRates.inperson_after_mins', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_after_mins) || '')
        setValue('interpretationRates.opi_after_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.opi_after_mins_time_unit) || ['hour'])
        setValue('interpretationRates.vri_after_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.vri_after_mins_time_unit) || ['hour'])
        setValue('interpretationRates.inperson_after_mins_time_unit', (item || selectedTemplate)?.interpretation_rates?.map(item => item.inperson_after_mins_time_unit) || ['hour'])

        if (item?.client_template) {
            setValue('client_template_id', item?.client_template?.id || '')
        }
    }, [item])

    const handleChangeTemplate = (filterTemplateObj) => {
        if (filterTemplateObj?.value) {
            const newTemplate = templates?.find(i => i.id === filterTemplateObj.value);
            setChangeTemplate(newTemplate);
            setValue('normal_hour_start_time', newTemplate?.normal_hour_start_time || '')
            setValue('normal_hour_end_time', newTemplate?.normal_hour_end_time || '')
            setValue('after_hour_start_time', newTemplate?.after_hour_start_time || '')
            setValue('after_hour_end_time', newTemplate?.after_hour_end_time || '')
            setValue('grace_period', newTemplate?.grace_period || '')
            setValue('incremental', newTemplate?.incremental || '')
            setValue('rush_fee', newTemplate?.rush_fee || '')

            setValue('interpretationRates.opi_normal_rate', newTemplate?.interpretation_rates?.map(item => item.opi_normal_rate) || '')
            setValue('interpretationRates.vri_normal_rate', newTemplate?.interpretation_rates?.map(item => item.vri_normal_rate) || '')
            setValue('interpretationRates.inperson_normal_rate', newTemplate?.interpretation_rates?.map(item => item.inperson_normal_rate) || '')
            setValue('interpretationRates.opi_normal_rate_time_unit', newTemplate?.interpretation_rates?.map(item => item.opi_normal_rate_time_unit) || ['hour'])
            setValue('interpretationRates.vri_normal_rate_time_unit', newTemplate?.interpretation_rates?.map(item => item.vri_normal_rate_time_unit) || ['hour'])
            setValue('interpretationRates.inperson_normal_time_unit', newTemplate?.interpretation_rates?.map(item => item.inperson_normal_time_unit) || ['hour'])
            setValue('interpretationRates.opi_normal_mins', newTemplate?.interpretation_rates?.map(item => item.opi_normal_mins) || '')
            setValue('interpretationRates.vri_normal_mins', newTemplate?.interpretation_rates?.map(item => item.vri_normal_mins) || '')
            setValue('interpretationRates.inperson_normal_mins', newTemplate?.interpretation_rates?.map(item => item.inperson_normal_mins) || '')
            setValue('interpretationRates.opi_normal_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.opi_normal_mins_time_unit) || ['hour'])
            setValue('interpretationRates.vri_normal_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.vri_normal_mins_time_unit) || ['hour'])
            setValue('interpretationRates.inperson_normal_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.inperson_normal_mins_time_unit) || ['hour'])

            setValue('interpretationRates.opi_after_rate', newTemplate?.interpretation_rates?.map(item => item.opi_after_rate) || '')
            setValue('interpretationRates.vri_after_rate', newTemplate?.interpretation_rates?.map(item => item.vri_after_rate) || '')
            setValue('interpretationRates.inperson_after_rate', newTemplate?.interpretation_rates?.map(item => item.inperson_after_rate) || '')
            setValue('interpretationRates.opi_after_rate_time_unit', newTemplate?.interpretation_rates?.map(item => item.opi_after_rate_time_unit) || ['hour'])
            setValue('interpretationRates.vri_after_rate_time_unit', newTemplate?.interpretation_rates?.map(item => item.vri_after_rate_time_unit) || ['hour'])
            setValue('interpretationRates.inperson_after_time_unit', newTemplate?.interpretation_rates?.map(item => item.inperson_after_time_unit) || ['hour'])
            setValue('interpretationRates.opi_after_mins', newTemplate?.interpretation_rates?.map(item => item.opi_after_mins) || '')
            setValue('interpretationRates.vri_after_mins', newTemplate?.interpretation_rates?.map(item => item.vri_after_mins) || '')
            setValue('interpretationRates.inperson_after_mins', newTemplate?.interpretation_rates?.map(item => item.inperson_after_mins) || '')
            setValue('interpretationRates.opi_after_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.opi_after_mins_time_unit) || ['hour'])
            setValue('interpretationRates.vri_after_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.vri_after_mins_time_unit) || ['hour'])
            setValue('interpretationRates.inperson_after_mins_time_unit', newTemplate?.interpretation_rates?.map(item => item.inperson_after_mins_time_unit) || ['hour'])

            // setValue('client_template_id', newTemplate?.id || '')
        }
        else {
            setChangeTemplate(undefined);

            setValue('interpretationRates.opi_normal_rate', '')
            setValue('interpretationRates.vri_normal_rate', '')
            setValue('interpretationRates.inperson_normal_rate', '')
            setValue('interpretationRates.opi_normal_rate_time_unit', ['hour'])
            setValue('interpretationRates.vri_normal_rate_time_unit', ['hour'])
            setValue('interpretationRates.inperson_normal_time_unit', ['hour'])
            setValue('interpretationRates.opi_normal_mins', '')
            setValue('interpretationRates.vri_normal_mins', '')
            setValue('interpretationRates.inperson_normal_mins', '')
            setValue('interpretationRates.opi_normal_mins_time_unit', ['hour'])
            setValue('interpretationRates.vri_normal_mins_time_unit', ['hour'])
            setValue('interpretationRates.inperson_normal_mins_time_unit', ['hour'])

            setValue('interpretationRates.opi_after_rate', '')
            setValue('interpretationRates.vri_after_rate', '')
            setValue('interpretationRates.inperson_after_rate', '')
            setValue('interpretationRates.opi_after_rate_time_unit', ['hour'])
            setValue('interpretationRates.vri_after_rate_time_unit', ['hour'])
            setValue('interpretationRates.inperson_after_time_unit', ['hour'])
            setValue('interpretationRates.opi_after_mins', '')
            setValue('interpretationRates.vri_after_mins', '')
            setValue('interpretationRates.inperson_after_mins', '')
            setValue('interpretationRates.opi_after_mins_time_unit', ['hour'])
            setValue('interpretationRates.vri_after_mins_time_unit', ['hour'])
            setValue('interpretationRates.inperson_after_mins_time_unit', ['hour'])

            setValue('normal_hour_start_time', '')
            setValue('normal_hour_end_time', '')
            setValue('after_hour_start_time', '')
            setValue('after_hour_end_time', '')
            setValue('grace_period', '')
            setValue('incremental', '')
            setValue('rush_fee', '')
        }
    }

    const invoiceOption = [
        {
            label: "Weekly",
            value: "weekly",
        },
        {
            label: "Bi-weekly",
            value: "bi-weekly",
        },
        {
            label: "Monthly",
            value: "monthly",
        }
    ];

    return (
        <>
            <div className="row-primary">
                <h2>Interpretation Rates Template *</h2>
                <div className='w-100'>
                    <Controller
                        name="client_template_id"
                        control={control}
                        rules={{
                            required: "Please select a template"
                        }}
                        render={({ field }) =>
                            <div style={{ width: "100%" }}>
                                {console.log("filterTemplate", field.value)}
                                <AsyncPaginate
                                    menuPlacement='auto'
                                    styles={{
                                        ...selectCustomStyles,
                                    }}
                                    value={filterTemplate}
                                    loadOptions={filteredTemplateLoadOptions}
                                    isClearable
                                    escapeClearsValue
                                    onChange={(obj) => {
                                        if (obj?.value) {
                                            setfilterTemplates(obj)
                                            field.onChange(obj.value);
                                            handleChangeTemplate(obj)
                                        }
                                        else {
                                            setfilterTemplates(null)
                                            field.onChange(null);
                                            handleChangeTemplate(null)
                                        }
                                    }}
                                    additional={{
                                        page: item?.state?.id ? 2 : 1,
                                    }}
                                />
                                {errors?.client_template_id?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.client_template_id?.message} />
                                    </div>
                                }
                            </div>
                        }
                    />
                </div>

                <h2>Invoicing Period *</h2>
                <div className='w-100'>
                    <Controller
                        name="invoicing_period"
                        rules={{
                            required: "Please select one"
                        }}
                        control={control}
                        render={({ field }) =>
                            <div className='select_box' style={{ width: "100%" }}>
                                <Select
                                    name="invoicing_period"
                                    options={invoiceOption || []}
                                    value={field.value ? invoiceOption?.find((opt) => field.value == opt.value) : ""}
                                    isClearable={false}
                                    disabledSearch={true}
                                    onChange={(value) => {
                                        field.onChange(value);
                                    }}
                                />
                            </div>
                        }
                    />
                    {errors?.invoicing_period?.message &&
                        <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.invoicing_period?.message} />
                        </div>
                    }
                </div>
            </div>
            {(changeTemplate || item || selectedTemplate)
                &&
                <>
                    {/* Normal Hours */}
                    <div className="row-primary m-0 row-r justify-content-between flex-row">
                        <h2 className='fst-italic fw-bold mt-0'>Normal Hours </h2>
                    </div>
                    <div className="foam_page_row">
                        <div className="row-primary">
                            <h2>Start Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                name="normal_hour_start_time"
                                rule="Please select start time"
                                onChange={handleNormalHoursChange}
                            />
                        </div>

                        <div className="row-primary">
                            <h2>End Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                name="normal_hour_end_time"
                                rule="Please select End time"
                                onChange={handleNormalHoursChange}
                            />
                        </div>
                    </div>

                    {/* After Hours */}
                    <div className="row-primary m-0 row-r justify-content-between flex-row">
                        <h2 className='fst-italic fw-bold mt-0'>After Hours </h2>
                    </div>
                    <div className="foam_page_row">
                        <div className="row-primary">
                            <h2>Start Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                name="after_hour_start_time"
                                rule="Please select start time"
                                onChange={handleAfterHoursChange}
                            />
                        </div>

                        <div className="row-primary">
                            <h2>End Time*</h2>
                            <TimeInput
                                errors={errors}
                                control={control}
                                name="after_hour_end_time"
                                rule="Please select End time"
                                onChange={handleAfterHoursChange}
                            />
                        </div>
                    </div>


                    {/* Grace Period */}
                    <div className='foam_page_row mt-3'>
                        <div className="row-primary">
                            <h2>Cancellation Grace Period(Hrs)</h2>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    name="grace_period"
                                    control={control}
                                    rules={{ required: "Please enter Grace Period" }}
                                    render={({ field }) => (
                                        <input className="input-in type_inp"
                                            type="number"
                                            name='grace_period'
                                            placeholder='Grace Period' required
                                            {...field}
                                            onChange={
                                                (e) => {
                                                    field.onChange(parseFloat(e.target.value));
                                                    if (e.target.value < 0) {
                                                        field.onChange(0);
                                                    }
                                                }
                                            }
                                        />
                                    )}
                                />
                                {errors?.grace_period?.message && <div style={{ marginBottom: 10 }}><ErrorMessage text={errors?.grace_period?.message} /></div>}
                            </div>
                        </div>

                        <div className="row-primary">
                            <h2>Incremental *</h2>
                            <Controller
                                name="incremental"
                                control={control}
                                render={({ field }) =>
                                    <div className='select_box' style={{ width: "100%" }}>
                                        <Select
                                            name="incremental"
                                            options={filterIncremental || []}
                                            value={field.value ? filterIncremental?.find((opt) => field.value == opt.value) : ""}
                                            isClearable={false}
                                            disabledSearch={true}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                handleChangeMinDuration(value)
                                            }}
                                        />
                                    </div>
                                }
                            />
                        </div>
                    </div>

                    {/* Rush Fee  */}
                    <div className='foam_page_row mt-3'>
                        <div className="row-primary">
                            <h2>Rush Fee *</h2>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    name="rush_fee"
                                    control={control}
                                    rules={{ required: "Please enter rush fee" }}
                                    render={({ field }) => (
                                        <input className="input-in type_inp" type="number" name='rush_fee' placeholder='Rush fee' {...field}
                                            onChange={
                                                (e) => {
                                                    field.onChange(parseFloat(e.target.value));
                                                    if (e.target.value < 0) {
                                                        field.onChange(0);
                                                    }
                                                }
                                            }
                                        />
                                    )}
                                />
                                {errors?.rush_fee?.message &&
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors?.rush_fee?.message} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </>
            }
            {(changeTemplate || item || selectedTemplate) &&
                ((changeTemplate?.interpretation_rates || item?.client_template?.tiers || selectedTemplate?.interpretation_rates) || []).map((val, index) => (
                    <div key={index} className='row-primary'>
                        <h2 className='fw-bold text-uppercase'>{val?.name || val?.tiers[0]?.name || 'N/A'}</h2>

                        <div>
                            <h2 className='text-center my-3 fw-bold fst-italic'>Normal Hours*</h2>

                            <div className='rate_container'>
                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Rates:</h2>
                                    <div className='Inter_rate_row'>
                                        <h4>OPI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.opi_normal_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.opi_normal_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>VRI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.vri_normal_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.vri_normal_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>In Person</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.inperson_normal_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.inperson_normal_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Minimum:</h2>
                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.opi_normal_mins.${index}`} placeholder='OPI minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.opi_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.vri_normal_mins.${index}`} placeholder='VRI minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.vri_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.inperson_normal_mins.${index}`} placeholder='In person minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.inperson_normal_mins_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h2 className='text-center my-3 fw-bold fst-italic'>After Hours*</h2>

                            <div className='rate_container'>
                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Rates:</h2>
                                    <div className='Inter_rate_row'>
                                        <h4>OPI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.opi_after_rate.${index}`} placeholder='OPI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.opi_after_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>VRI</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.vri_after_rate.${index}`} placeholder='VRI rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.vri_after_rate_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <h4>In Person</h4>
                                        <div className='inter_wrapper'>
                                            <RateInput control={control} name={`interpretationRates.inperson_after_rate.${index}`} placeholder='In person rate' currency_symbol={true} />
                                            <UnitSelect control={control} name={`interpretationRates.inperson_after_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary align-items-end">
                                    <h2 className='mb-3 my-0'>Minimum:</h2>
                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.opi_after_mins.${index}`} placeholder='OPI minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.opi_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.vri_after_mins.${index}`} placeholder='VRI minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.vri_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>

                                    <div className='Inter_rate_row'>
                                        <div className='inter_wrapper'>
                                            <RateInput errors={errors} control={control} name={`interpretationRates.inperson_after_mins.${index}`} placeholder='In person minimun' />
                                            <UnitSelect control={control} name={`interpretationRates.inperson_after_mins_time_unit.${index}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default LanguageTiers